import { EntityNotFound } from '@/components/entity-not-found';
import axios from 'axios';
import { PropsWithChildren } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

/**
 * Error boundary specifically for customer-related routes.
 * Catches 404 errors and displays a proper not found page instead of generic error messages.
 */
export function CustomerErrorBoundary(props: PropsWithChildren) {
  const handleError = (error: Error) => {
    if (axios.isAxiosError(error) && error.response?.status === 404) {
      return (
        <EntityNotFound
          entityType="customer"
          listPath="/customers"
          listLabel="Go to customers"
        />
      );
    }

    throw error;
  };

  return (
    <ErrorBoundary
      fallbackRender={({ error }) => handleError(error)}
      onError={(error) => {
        if (!axios.isAxiosError(error) || error.response?.status !== 404) {
          throw error;
        }
      }}
    >
      {props.children}
    </ErrorBoundary>
  );
}
